<template>
    <Page>
        <Container>
            <div class="mx-auto max-w-sm">
                <Help>
                    Manage reusable workout templates for the routines you repeat most often.
                </Help>
                <TemplateResourceList :key="$route.fullPath" />
            </div>
        </Container>
    </Page>
</template>

<script>
import {defineComponent} from 'vue'
import Help from '@/components/Help.vue';
import TemplateResourceList from '@/components/Template/ResourceList.vue';

export default defineComponent({
  name: 'Index',
  components: {
    Help,
    TemplateResourceList,
  },
});
</script>

<style scoped lang="scss">

</style>
